import React from 'react';
import IconWrapper from '../../../IconWrapper';
const ArrowRightIconMedium = (props) => (React.createElement(IconWrapper, { ...props },
    React.createElement("path", { d: "M11.845 2.138a.5.5 0 0 0-.69.724l9.093 8.638H2.5a.5.5 0 0 0 0 1h17.748l-9.092 8.637a.5.5 0 0 0 .688.726l10-9.5a.5.5 0 0 0 0-.726l-10-9.5Z" })));
export default ArrowRightIconMedium;
//# sourceMappingURL=ArrowRightIconMedium.js.map